import { render } from "./Toast.vue?vue&type=template&id=50897f6a&bindings={}"
import script from "./Toast.vue?vue&type=script&lang=ts"
export * from "./Toast.vue?vue&type=script&lang=ts"

import "./Toast.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script